const hasPromosEnabled = libraryMap => {
  const hasCms = libraryMap?.get('cmsEnabled') ?? false;
  const hasPromos = libraryMap?.get('hasPromos') ?? false;
  const hasPromosAddOn = libraryMap.get('hasPromosAddOn') ?? false;

  return hasPromos && (hasCms || hasPromosAddOn);
};

export default hasPromosEnabled;
